import type { TemplateOnlyComponent } from '@ember/component/template-only';

export interface Signature {
  Args: {
    class?: string;
  };
  Element: SVGElement;
}

const WrScanIconComponent: TemplateOnlyComponent<Signature> = <template>
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    class={{@class}}
    ...attributes
  >
    <path
      d='M15 4.36364V4.54545C15 4.90909 14.7273 5.18182 14.3636 5.18182C14 5.18182 13.7273 4.90909 13.7273 4.54545V4.36364C13.7273 3.18182 12.8182 2.27273 11.6364 2.27273H11.4545C11.0909 2.27273 10.8182 2 10.8182 1.63636C10.8182 1.27273 11.0909 1 11.4545 1H11.6364C13.4545 1 15 2.54545 15 4.36364ZM4.54545 13.7273H4.36364C3.18182 13.7273 2.27273 12.8182 2.27273 11.6364V11.4545C2.27273 11.0909 2 10.8182 1.63636 10.8182C1.27273 10.8182 1 11.0909 1 11.4545V11.6364C1 13.4545 2.54545 15 4.36364 15H4.54545C4.90909 15 5.18182 14.7273 5.18182 14.3636C5.18182 14 4.90909 13.7273 4.54545 13.7273ZM14.3636 10.8182C14 10.8182 13.7273 11.0909 13.7273 11.4545V11.6364C13.7273 12.8182 12.8182 13.7273 11.6364 13.7273H11.4545C11.0909 13.7273 10.8182 14 10.8182 14.3636C10.8182 14.7273 11.0909 15 11.4545 15H11.6364C13.4545 15 15 13.4545 15 11.6364V11.4545C15 11.0909 14.7273 10.8182 14.3636 10.8182ZM1.63636 5.18182C2 5.18182 2.27273 4.90909 2.27273 4.54545V4.36364C2.27273 3.18182 3.18182 2.27273 4.36364 2.27273H4.54545C4.90909 2.27273 5.18182 2 5.18182 1.63636C5.18182 1.27273 4.90909 1 4.54545 1H4.36364C2.54545 1 1 2.54545 1 4.36364V4.54545C1 4.90909 1.27273 5.18182 1.63636 5.18182ZM9.81818 12.2727H6.18182C4.81818 12.2727 3.72727 11.1818 3.72727 9.81818V6.18182C3.72727 4.81818 4.81818 3.72727 6.18182 3.72727H9.81818C11.1818 3.72727 12.2727 4.81818 12.2727 6.18182V9.81818C12.2727 11.1818 11.1818 12.2727 9.81818 12.2727ZM11 6.18182C11 5.54545 10.4545 5 9.81818 5H6.18182C5.54545 5 5 5.54545 5 6.18182V9.81818C5 10.4545 5.54545 11 6.18182 11H9.81818C10.4545 11 11 10.4545 11 9.81818V6.18182Z'
      fill='currentColor'
    />
  </svg>
</template>;

export default WrScanIconComponent;
